import { render, staticRenderFns } from "./Database_wrap.vue?vue&type=template&id=8f8ae842"
import script from "./Database_wrap.vue?vue&type=script&lang=js"
export * from "./Database_wrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports